// Message
export const MSG_GRN_SUCCESS = "GRN Created Successfully!";
export const MSG_GRN_FAILED = "Failed to create GRN. Please try again.";

export const MSG_GRN_SAVE = "GRN Saved Successfully!";
export const MSG_GRN_SAVE_FAILED = "Failed to save GRN. Please try again.";

export const MSG_GRN_HOLD = "GRN Hold Successfully!";
export const MSG_GRN_HOLD_FAILED = "Failed to hold GRN. Please try again.";

export const LOGIN_SUCCESS = "Hi, Welcome Back!";
export const LOGIN_FAILED =
  "Login failed. Please check your credentials and try again.!";

export const MSG_GRN_UPDATE = "GRN Updated Successfully!";
export const MSG_GRN_UPDATE_FAILED = "Failed to update GRN. Please try again.";

export const MSG_GRN_DELETE = "Item Deleted Successfully!";
export const MSG_GRN_DELETE_FAILED = "Failed to Delete Item. Please try again.";
